import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getFilters } from '../../webcommon/header/filterheader/selectors';

import * as actions from './actions';
import * as selectors from './selectors';
import * as drilldownActions from '../csadrilldown/actions';
import MonitoringSummaryView from './MonitoringSummaryView';

const mapStateToProps = state => ({
    columns: selectors.getColumns(state),
    rows: selectors.getImSummaries(state),
    lastUpdated: selectors.getLastUpdated(state),
    loading: selectors.getLoading(state),
    dateFrom: selectors.getDateFrom(getFilters(state, 'MonitoringSummary')),
    dateTo: selectors.getDateTo(getFilters(state, 'MonitoringSummary')),
    csas: selectors.getCsas(getFilters(state, 'MonitoringSummary')),
    defaultSort: selectors.getDefaultSort(state),
    useDollars: selectors.getUseDollars(state)
});

const mapDispatchToProps = {
    initialise: actions.initialise,
    refreshData: actions.refreshData,
    setMonitoringSummariesColumns: actions.setMonitoringSummariesColumns,
    csvExportEmpty: actions.csvExportEmpty,
    setGridSorts: actions.setGridSorts,
    switchCurrencies: actions.switchCurrencies,
    setDrilldownFilters: drilldownActions.setDrilldownFilters,
    refreshMonitoringSummary: actions.refreshMonitoringSummary
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(MonitoringSummaryView)
);
